/* eslint-disable no-unused-vars */
export enum AssignmentActionStatus {
  Deactivated = 'deactivated',
  Assigned = 'assigned',
  Deassigned = 'deassigned',
  NoAssignmentAction = 'no_assignment_action',
}
